const encryptChannel = (channelName: string) => `enc:${channelName}`;

export const operationsLogsChannelName = (personId: string) => {
  return encryptChannel(
    `api/dugout/reward_cards/operations_logs/?is_completed=false&person_id=${personId}`
  );
};

export const rewardCardAccountsChannelName = (personId: string) => {
  return encryptChannel(`api/dugout/reward_cards/accounts/?person_id=${personId}`);
};

export const pendingTransactionsChannelName = (personId: string) => {
  return encryptChannel(
    `api/dugout/reward_cards/transactions/?person_id=${personId}&is_pending=true`
  );
};

export const datePaginatedTransactionsChannelName = (personId: string) => {
  return encryptChannel(
    `api/dugout/reward_cards/transactions/date_paginated/?person_id=${personId}&is_pending=false`
  );
};

export const createHealthieAccountChannelName = (personId: string) => {
  return encryptChannel(`api/dugout/people/create_healthie_account/?person_id=${personId}`);
};

export const personMessagesChannelName = (personId: string) => {
  return encryptChannel(`api/dugout/messaging/?person_id=${personId}`);
};

export const profileAiChatChannelName = (personId: string, userId: string | undefined) => {
  return encryptChannel(`api/dugout/patient_profile_chat/query/${personId}/${userId}/`);
};

export const billingReportChannelName = (
  billingReportId: string,
  billingReportResultId: string
) => {
  return encryptChannel(`billing-report-${billingReportId}-${billingReportResultId}`);
};

export const billingItemsChannelName = () => {
  return encryptChannel('billing-items');
};

export const userChannelName = (userId: string) => {
  return encryptChannel(`private-user-${userId}`);
};

export const generatedDocumentsChannelName = (personId: string) => {
  return encryptChannel(`api/generated_documents/?person_id=${personId}`);
};

export const personAvailabilityChannelName = (personId: string) => {
  return encryptChannel(`api/dugout/availability/?person_id=${personId}`);
};

export const scheduleExpectationsChannelName = (personId: string) => {
  return encryptChannel(`api/appointments/schedule_expectation_cycles/?person_id=${personId}`);
};

// Mirrors EncounterChecklistPublisher.channel_name on the backend
export const encounterChecklistChannelName = (personId: string) => {
  return encryptChannel(`api/dugout/encounters/checklist/?person_id=${personId}`);
};

// Mirrors EncounterChecklistPresence.space_name on the backend
export const encounterChecklistSpaceName = (personId: string) => `encounter-checklist-${personId}`;
